import * as Yup from "yup";

const formatDateToInput = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const year = date.getFullYear();
  let month = (date.getMonth() + 1).toString().padStart(2, "0");
  let day = date.getDate().toString().padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export function initialValues(registeredPayment, debtDetails, calculatedLateFee) {
  let pendingTuition = 0;
  if (debtDetails) {
    pendingTuition = parseFloat(debtDetails.amount_pending) > 0 
      ? parseFloat(debtDetails.amount_pending) 
      : (parseFloat(debtDetails.amount_paid) > 0 ? 0 : parseFloat(registeredPayment?.PaymentConcept?.amount || 0));
  } else {
    pendingTuition = parseFloat(registeredPayment?.pendingTuition) > 0
      ? parseFloat(registeredPayment.pendingTuition)
      : (parseFloat(registeredPayment?.totalPaid) > 0 ? 0 : parseFloat(registeredPayment?.PaymentConcept?.amount || 0));
  }
    
  const accumulatedLateFee = debtDetails 
    ? parseFloat(debtDetails.late_fees_accumulated) 
    : parseFloat(calculatedLateFee || 0);

  const totalPaidLateFee = parseFloat(registeredPayment?.totalPaidLateFee || 0);
  const safeTuition = isNaN(pendingTuition) ? 0 : pendingTuition;
  const safeLateFee = Math.max(0, (isNaN(accumulatedLateFee) ? 0 : accumulatedLateFee) - totalPaidLateFee);
  const isWaived = registeredPayment?.isLateFeeWaived || false;

  return {
    transactionCode: "",
    paymentMethod: "",
    paymentDate: formatDateToInput(new Date()),
    tuitionAmount: safeTuition.toFixed(2),
    lateFeeAmount: isWaived ? "0.00" : safeLateFee.toFixed(2),
    totalAmount: (safeTuition + (isWaived ? 0 : safeLateFee)).toFixed(2),
    isLateFeeWaived: isWaived,
    path: "",
    voucher: null,
  };
}

export function validationSchema(maxTuition) {
  return Yup.object().shape({
    transactionCode: Yup.string().nullable(),
    paymentMethod: Yup.number().required("El método de pago es obligatorio"),
    paymentDate: Yup.date()
      .required("La fecha de pago es obligatoria")
      .typeError("La fecha de pago debe ser una fecha válida"),
    voucher: Yup.mixed()
      .required("Es obligatorio subir un comprobante (voucher)")
      .test("fileType", "El archivo debe ser una imagen (PNG o JPG)", (value) => {
        if (!value) return false;
        const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
        return allowedTypes.includes(value.type);
      }),
    tuitionAmount: Yup.number()
      .required("El pago de cuota es obligatorio")
      .min(0, "El monto no puede ser menor a 0")
      .max(maxTuition + 0.01, `El monto de cuota no puede exceder el pendiente de S/ ${maxTuition}`),
    lateFeeAmount: Yup.number()
      .required("El pago de mora es obligatorio")
      .min(0, "La mora no puede ser menor a 0"),
    totalAmount: Yup.number().required("El total es obligatorio"),
    isLateFeeWaived: Yup.boolean().nullable(),
  });
}
